import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import SocialProof from "@/components/SocialProof";
import ArchitectsSection from "@/components/ArchitectsSection";
import GallerySection from "@/components/GallerySection";
import ContactSection from "@/components/ContactSection";
import FAQSection from "@/components/FAQSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import SEO from "@/components/SEO";

const Index = () => {
  const localBusinessJsonLd = {
    "@context": "https://schema.org",
    "@type": "RoofingContractor",
    name: "אור בגג",
    description:
      "מומחה גגות ופחחות בחיפה והקריות עם 13 שנות ניסיון – איתור נזילות, מרזבים, פחחות ואוורור גגות",
    url: "https://orbagag.com",
    telephone: "+972-54-572-5681",
    email: "or.perias@gmail.com",
    image: "https://orbagag.com/og-image.jpg",
    priceRange: "₪₪",
    areaServed: ["חיפה", "קריות", "נשר", "עכו", "יקנעם", "טירת כרמל", "עתלית"],
    address: {
      "@type": "PostalAddress",
      addressCountry: "IL",
      addressLocality: "חיפה והסביבה",
    },
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
        opens: "07:00",
        closes: "18:00",
      },
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: "Friday",
        opens: "07:00",
        closes: "13:00",
      },
    ],
  };

  return (
    <div className="min-h-screen">
      <SEO path="/" jsonLd={localBusinessJsonLd} />
      <Header />
      <main id="main">
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <SocialProof />
        <ArchitectsSection />
        <GallerySection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
